'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions, combineActions } from 'flux-actions';
import Branding from 'MeetingsBase/models/Branding';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
var initialState = new Branding();
export default handleActions(_defineProperty({}, combineActions(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED), function (state, action) {
  if (action.payload && action.payload.branding && action.payload.branding.primaryColor !== null) {
    var _action$payload$brand = action.payload.branding,
        primaryColor = _action$payload$brand.primaryColor,
        logoUrl = _action$payload$brand.logoUrl,
        logoAltText = _action$payload$brand.logoAltText,
        companyName = _action$payload$brand.companyName;
    return state.set('primaryColor', primaryColor).set('logoUrl', logoUrl).set('logoAltText', logoAltText).set('companyName', companyName);
  }

  return state;
}), initialState);